import { HttpClient } from '@angular/common/http';
import { Component, Input, NgZone, OnInit } from '@angular/core';
import { SummaryPricesTextsService } from './summary-prices-texts.service';
import { PagesValidationService } from '../../order-fulfillment/pages-validation.service';
import { LoadersService } from '../../utils/loaders/loaders.service';
import { SummaryPricesService } from './summary-prices.service';
import SlotService from '../../cart-process/slot.service';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { combineLatest } from 'rxjs';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { PageValidationErrorNamesEnum } from '../../models/page-validation-error-names.enum';
import { TaxNameEnum } from '../../models/cartDetails/tax-name.enum';
import { SelectedAgreementsService } from '../../customer-form/agreements/selected-agreements.service';
import { SubmitOrderService } from '../../order-fulfillment/submit-order.service';
import { CommonModalService } from '../../utils/modals/common-modal.service';
import { LoaderActions } from '../../utils/loaders/loader-actions.enum';
import PageValidateModel from '../../models/page-validate.model';
import { DeliveryFormStateService } from '../../customer-form/form-state/delivery-form-state.service';
import { hiddenElementSlideInOut, slideInOut } from '../../utils/animations/slides.animation';
import { DecoratePricePipe } from '../../utils/pipes/price-format.pipe';
import { ICartDetails, IPrice } from '../../interfaces/cart-details.interface';
import SlotModel from '../../models/slot.model';
import { CartClearConfirmationService } from '../../services/cart-clear-confirmation.service';
import { FormSectionTypeEnum, FormStepsService } from '../../customer-form/form-steps/form-steps.service';
import { CommonModalTemplatesEnum } from '../../utils/modals/common-modal-templates.enum';
import { IMaxOrderValue } from '../../utils/modals/common-modal.interface';
import { PromotionTypeEnum } from '../../models/cartDetails/promotionType.model';
import { TranslateService } from '@ngx-translate/core';
import { SummaryPricesGroupModel } from './summary-prices-group.model';
import { PriceGroupEnum } from '../../models/cartDetails/price-group.enum';

declare const window: any;

@Component({
  selector: 'summary-prices-component',
  templateUrl: './summary-prices.component.html',
  animations: [slideInOut, hiddenElementSlideInOut]
})
export class SummaryPricesComponent implements OnInit {
  public isFirstPage: boolean;
  public isSecondPage: boolean;
  public isThirdPage: boolean;
  public isFourthPage: boolean;
  public automationId: string;
  public isLoaderVisible: boolean;
  public isInstallmentFlex: boolean;
  public isOnlyRegularOffer: boolean;
  public isMixOffer: boolean;
  public isOfferWithDevice: boolean;
  public summaryPrices: SummaryPricesService;
  public isBackButtonVisible: boolean;
  public backButtonText: string;
  public allowSubmitOrder = false;
  public discountTip: string = null;
  public summaryTableWrapperExpanded = false;
  public allSlots: SlotModel[];
  public pointOfServiceUrl: string;
  public callCenterUrl: string;
  public isVirginBrand = false;
  public isTooltipVisible = false;
  public showDeliveryCost = false;
  public isDeviceOffer = false;
  public isNextSim = false;
  public tooltipContent: string;
  private isRequestPending = false;
  private isBackButtonVisibleFirstPage: boolean;
  private priceFormat: DecoratePricePipe;
  public formSectionTypeEnum: typeof FormSectionTypeEnum = FormSectionTypeEnum;
  public isRetentionBeforeEOP: boolean;
  public slots: SlotModel[];
  public promotionType: PromotionTypeEnum;
  public requiredParticipants: number;
  public deliveryCurrencySymbol: string;
  public isB2C: boolean;
  public isInstallmentOldContract: boolean;

  @Input() linknext: string;
  @Input() deliveryCost: IPrice;

  constructor(
    public texts: SummaryPricesTextsService,
    public commonInfo: CommonInfoService,
    public formStepsService: FormStepsService,
    public slotService: SlotService,
    public translate: TranslateService,
    private commonModalService: CommonModalService,
    private submitOrderService: SubmitOrderService,
    private selectedAgreementsService: SelectedAgreementsService,
    private pagesValidation: PagesValidationService,
    private loadersService: LoadersService,
    private notificationProvider: NotificationProviderService,
    private deliveryFormStateService: DeliveryFormStateService,
    private _ngZone: NgZone,
    private summaryPricesService: SummaryPricesService,
    private cartClearConfirmationService: CartClearConfirmationService,
    private http: HttpClient
  ) {
    window['SummaryPricesComponentRef'] = {component: this, zone: _ngZone};
  }

  ngOnInit(): void {
    this.isVirginBrand = this.commonInfo.isVirginBrand;
    this.priceFormat = new DecoratePricePipe(this.commonInfo);
    this.backButtonText = this.texts.getBackButtonText();
    this.showDeliveryCost = this.commonInfo.isThirdPage || this.commonInfo.isFourthPage || this.commonInfo.isOtherSalesOffer;
    this.isB2C = this.commonInfo.b2c;

    this.slots = this.slotService.getSlots();
    this.isMixOffer = this.commonInfo.isServiceTypeMix;
    this.isOfferWithDevice = !!this.slots.find(slot => slot.device);
    this.isInstallmentOldContract = !!this.slots.find(slot => slot.oldContractEndingDate && !slot.offerChangePrices?.subsidy?.length);

    this.loadersService.registerLoader(this.loadersService.loaderActions.SUMMARY_PRICES_LOADER).subscribe((context: any) => {
      this.isLoaderVisible = context.visible;
    });

    combineLatest([
      this.notificationProvider.getSubject(NotificationProviderTypeEnum.CART_DETAILS),
      this.notificationProvider.getSubject(NotificationProviderTypeEnum.COMMON_INFO)
    ]).subscribe((context: [ICartDetails, CommonInfoService]) => {
      const [cartDetails, commonInfoService]: [ICartDetails, CommonInfoService] = context;
      if (cartDetails && commonInfoService) {
        this.updateData(cartDetails, commonInfoService);
        const otherSalesDeliveryCost = {
          gross: '12.00',
          net: '9.76'
        };
        const otherSalesFreeDeliveryCost = {
          gross: '0.00',
          net: '0.00'
        };

        const deliveryCost = this.commonInfo.isOtherSalesOffer ?
          cartDetails.summaryPrices[0].prices[0].price[commonInfoService.taxName] > 150
            ? otherSalesFreeDeliveryCost
            : otherSalesDeliveryCost
          : this.deliveryCost;

        this.summaryPricesService.preparePrices(cartDetails, commonInfoService, deliveryCost);
        this.isRetentionBeforeEOP = this.summaryPricesService.isRetentionBeforeEOP;
        this.summaryPrices = this.summaryPricesService;
        this.deliveryCurrencySymbol = !this.isB2C && parseFloat(this.summaryPrices.deliveryCost) > 0 ? 'zł + VAT' : 'zł';

        this.notificationProvider.publish(NotificationProviderTypeEnum.SUMMARY_PRICES, this);
      }
    });

    this.tooltipContent = this.summaryPrices.discountInformation;

    if (this.isFirstPage) {
      this.notificationProvider.subscribe(
        NotificationProviderTypeEnum.PAGE_VALIDATION_CART, (validationResult: PageValidateModel) => {
          if (!validationResult) {
            return;
          }

          this.allowSubmitOrder = !validationResult.showLead;
        }
      );
    } else {
      this.allowSubmitOrder = true;
    }
  }

  public getPrice(price: any): number {
    return price.price[this.commonInfo.taxName];
  }

  private updateData(cartDetails: ICartDetails, commonInfo: CommonInfoService): void {
    this.allSlots = this.slotService.getAllSlots();
    this.slots = this.slotService.getSlots();
    this.discountTip = null;
    this.isFirstPage = commonInfo.isFirstPage;
    this.isSecondPage = commonInfo.isSecondPage;
    this.isThirdPage = commonInfo.isThirdPage;
    this.isFourthPage = commonInfo.isFourthPage;
    this.isNextSim = commonInfo.isNextSim;
    // Temporary hidden for brand Play
    this.isBackButtonVisibleFirstPage = !this.slotService.hasLeasing() && this.isFirstPage && !commonInfo.isRetentionMultiOffer && !this.isNextSim && this.isVirginBrand;
    this.isBackButtonVisible = this.isBackButtonVisibleFirstPage || this.isFourthPage;
    const sourceUrl = window.location.href;
    this.pointOfServiceUrl = cartDetails.portalLeadUrl?.pointOfService ? `${cartDetails.portalLeadUrl?.pointOfService}&source_url=${sourceUrl}` : undefined;
    this.callCenterUrl = cartDetails.portalLeadUrl?.callCenter ? `${cartDetails.portalLeadUrl?.callCenter}&source_url=${sourceUrl}` : undefined;
    this.isInstallmentFlex = !!this.allSlots.find((slot) => slot.promotionType === PromotionTypeEnum.INSTALLMENT_FLEX);
    this.isOnlyRegularOffer = !this.allSlots.find((slot) => slot.promotionType === PromotionTypeEnum.INSTALLMENT_FLEX)
      && !!this.allSlots.find((slot) => slot.promotionType === PromotionTypeEnum.REGULAR);
    this.isDeviceOffer = !!this.allSlots.find((slot) => slot.hasDevice);
    this.requiredParticipants = this.commonInfo.simCardDiscount?.requiredParticipants;

    if (this.isFirstPage) {
      this.automationId = 'second-page-submit';
    } else if (this.isSecondPage) {
      this.automationId = 'third-page-submit';
    } else if (this.isThirdPage) {
      this.automationId = 'fourth-page-submit';
    }

    if ((!this.commonInfo.isNextSim && this.commonInfo.simCardDiscount && this.commonInfo.simCardDiscountApplied === true)
      || (this.commonInfo.isNextSim && this.slots.length + this.commonInfo.currentlyProcessed >= this.requiredParticipants && this.commonInfo.currentlyProcessed <= this.requiredParticipants - 1)) {
      const price = this.commonInfo.simCardDiscount[this.commonInfo.taxName];

      this.discountTip = `Otrzymujesz rabat <b>${this.priceFormat.transform(price)} miesięcznie</b> ${!this.commonInfo.isNextSim ? `za zakup umowy dla ${this.requiredParticipants}+ numerów!` : ''}`;
    }
  }

  public backButton(): void {
    window.location.href = window.PORTAL_URL || '/';
  }

  public submitButton(): void {
    if (!this.allowSubmitOrder) {
      return;
    }

    this.processSubmit();
  }

  public processSubmit(): void {
    if (this.isFirstPage && !this.isRequestPending) {
      this.isRequestPending = true;

      this.pagesValidation.firstPageValidation()
        .then(() => {
          this.startLoader();

          this.http.post(this.linknext, {},  { responseType: 'text'} )
            .subscribe(() => {
              window.location.href = this.linknext;
          });
        })
        .catch(([errorName, params]: any[]) => {
          this.isRequestPending = false;

          if (errorName === PageValidationErrorNamesEnum.CART_VALUE_EXCEEDED && params) {
            const modalData: IMaxOrderValue = params;

            modalData.templateName = CommonModalTemplatesEnum.MAX_ORDER_VALUE;
            modalData.maxOrderValue = String(modalData.maxOrderValue).replace('.', ',');
            modalData.taxDescription = params.taxName === TaxNameEnum.NET ? 'netto' : 'brutto';

            setTimeout(() => {
              this.commonModalService.setData(modalData);
            }, 500);
          }
        });

    } else if (this.isSecondPage) {
      this.pagesValidation.secondPageValidation((validationResult: any) => {

        if (validationResult) {
          if (this.selectedAgreementsService.areAgreementsAvailable()) {
            this.selectedAgreementsService.checkAgreements()
              .then((response: any) => {
                if (this.hasNipNumberInOtherSalesOffer()) {
                  return this.submitOrderService.allowNipNumber(this.hasNipNumberInOtherSalesOffer())
                    .then((isBlacklisted: boolean) => {
                      if (isBlacklisted) {
                        this.showOtherSalesErrorModal();
                      } else {
                        return response;
                      }
                    })
                    .catch(() => {
                      this.submitOrderService.showErrorPage();
                    });
                }

                return response;
              })
              .then((response: any) => {
                if (this.selectedAgreementsService.isUnlimitedGbAgreements(response)) {
                  this.selectedAgreementsService.startUnlimitedGbModal(response, this.sendOrder.bind(this));
                } else if (!this.selectedAgreementsService.isMarketingAgreements(response)) {
                  this.selectedAgreementsService.startMarketingModal(response, this.sendOrder.bind(this));
                } else {
                  this.sendOrder();
                }
              })
              .catch(() => {
                window.location.href = '/cart/multi/error';
              });
          } else if (this.hasNipNumberInOtherSalesOffer()) {
            this.submitOrderService.allowNipNumber(this.hasNipNumberInOtherSalesOffer())
              .then((isBlacklisted: boolean) => {
                if (isBlacklisted) {
                  this.showOtherSalesErrorModal();
                } else {
                  this.sendOrder();
                }
              })
              .catch(() => {
                this.submitOrderService.showErrorPage();
              });
          } else {
            this.sendOrder();
          }

          return;
        }

        this.saveOrder();
      });

    } else if (this.isThirdPage) {
      this.pagesValidation.thirdPageValidation((validationResult: any) => {

        if (validationResult) {
          this.sendOrder();

          return;
        }

        this.saveOrder();
      });
    }
  }

  private sendOrder(): void {
    this.deliveryFormStateService.storeData().save();
    this.submitOrderService.submitOrder();
    this.submitOrderService.storeCartStep().save();

    if (this.isSecondPage) {
      this.submitOrderService.storeFormData().save();
    }
  }

  private saveOrder(): void {
    this.submitOrderService.saveOrder();
  }

  private startLoader(): void {
    this.loadersService.start(
      LoaderActions.MODAL_LOADER,
      {
        message: '',
        preventClose: true
      },
      true
    );
  }

  private hasNipNumberInOtherSalesOffer(): string | undefined {
    if (this.commonInfo.isOtherSalesOffer) {
      const formData = this.submitOrderService.resolveData();
      const hasNipNumber = formData.find(item => item.name === 'companyNumber')?.value;

      return hasNipNumber;
    }

    return undefined;
  }

  public showOtherSalesErrorModal(): void {
    const modalData = {
      templateName: CommonModalTemplatesEnum.NIP_BLACKLISTED,
      closeModal: (event: Event) => {
        event.preventDefault();

        this.cartClearConfirmationService.clearData();
      },
      goToHomePage: (event: Event) => {
        event.preventDefault();

        this.cartClearConfirmationService.justClearData();

        window.location.replace('//play.pl');
      }
    };

    this.commonModalService.setData(modalData);
  }

  isPriceRowVisible(summaryPriceData: SummaryPricesGroupModel): boolean {
    if (summaryPriceData.group === PriceGroupEnum.DEVICES_AND_ACCESSORIES && summaryPriceData.isMonthly) {
      return this.isDeviceOffer;
    } else {
      return true;
    }
  }
}
